// NOTE: This entry point mounts the AccountDropdown into a plain server-rendered
// page (the global header), NOT inside the React Router SPA. There is no Router
// context here, so any child must use full-page navigation (plain `<a href>`),
// not react-router's `Link`/`history.push` — those throw "Invariant failed".
// Do not wrap this in a Router just to satisfy a Link; the dropdown renders on
// pages that are not part of the SPA.
import { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AccountDropdown } from '@hungryroot/app-mhr';

import { queryClientOptions } from '@hungryroot/rest';
import { useNextOrder } from '@hungryroot/rest-hooks';
import { renderApp } from './utils/utils';

function getLocalStorageProp(trackingProp: string) {
  return window.localStorage.getItem(trackingProp) !== null;
}

function Init() {
  const [hasTrackingProp, setHasTrackingProp] = useState(false);
  const { order } = useNextOrder();

  const customerCredit = window.customer_credit;

  const accountBalance = customerCredit;
  const trackingProp = 'hr_dropdown_tooltip_shown';
  const showTooltip = order
    ? order.show_badge && !hasTrackingProp && accountBalance > 0
    : false;

  useEffect(() => {
    setHasTrackingProp(getLocalStorageProp(trackingProp));
  }, []);

  return (
    <AccountDropdown
      testid="header-account-dropdown"
      accountBalance={customerCredit}
      showTooltip={showTooltip}
      tooltipTrackingProp={trackingProp}
    />
  );
}

function renderAccountDropdown() {
  const queryClientInstance = new QueryClient(queryClientOptions);

  renderApp(
    <QueryClientProvider client={queryClientInstance}>
      <Init />
    </QueryClientProvider>,
    'account-dropdown-component'
  );
}

if (document.getElementById('account-dropdown-root') !== null) {
  renderAccountDropdown();
}
